import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import CustomModal from '../customModal';
import AttributeQuestion from '../attributeQuestion';
import NoDataText from '../noDataText';
import Scrollbars from '../scrollbars';
import { isArray, isArrayEmpty } from '../../../utility/helpers';
import { ATTRIBUTES } from '../../../constants/attributes';
import { ATTRIBUTE_TYPES_MAP } from '../../pages/attributesPage/config';
import { getQuestionText } from '../../../utility/uiUtils';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  paper: {
    boxSizing: 'border-box',
    width: 850,
    height: 472,
  },
  root: {
    borderTop: `1px solid ${primary.bluish5}`,
    display: 'flex',
    paddingTop: spacing(9),
    position: 'relative',
    width: '100%',
    height: '100%',
    minHeight: 0,

    '&::before': {
      backgroundColor: primary.bluish5,
      content: '""',
      position: 'absolute',
      top: -1,
      left: -32,
      width: 32,
      height: 1,
    },
    '&::after': {
      backgroundColor: primary.bluish5,
      content: '""',
      position: 'absolute',
      top: -1,
      right: -32,
      width: 32,
      height: 1,
    },
  },
  scrollWrapper: {
    width: '100%',
    minHeight: 0,
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  contentNoData: {
    height: '100%',
    alignItems: 'center',
  },
  attribute: {
    width: 640,
  },
  question: {
    marginBottom: spacing(6),
    height: 'auto',
    '&:last-of-type': {
      marginBottom: 0,
    },
  },
  noData: {
    marginTop: spacing(-9),
    textAlign: 'center',
  },
  scrollY: {
    right: -20,
  },
}));

const PreviewAttributeDialog = ({
  translations,
  attribute,
  isOpened,
  onClose,
}) => {
  const classes = useStyles();
  const hasQuestions =
    isArray(attribute?.questions) && !isArrayEmpty(attribute?.questions);
  const isOpenEnded = attribute?.text_reply_questions;
  const isEnps = attribute.type === ATTRIBUTE_TYPES_MAP.ENPS.id;

  return (
    <CustomModal
      paperClass={classes.paper}
      isOpened={isOpened}
      title={translations.preview}
      onClose={onClose}
      shouldRemoveFooter
    >
      <div className={classes.root}>
        <div className={classes.scrollWrapper}>
          <Scrollbars verticalScrollClass={classes.scrollY}>
            <div
              className={classNames(classes.content, {
                [classes.contentNoData]: !hasQuestions,
              })}
            >
              {hasQuestions && (
                <div className={classes.attribute}>
                  {attribute.questions.map(question => {
                    const updatedQuestion = isEnps
                      ? {
                          ...question,
                          text: getQuestionText(
                            question.text,
                            attribute.created_by?.first_name
                          ),
                        }
                      : question;
                    const isEnpsOpenEndedQuestion =
                      isEnps && isArrayEmpty(question.answers);

                    return (
                      <AttributeQuestion
                        key={`question_${question.id}`}
                        scrollClass={classes.question}
                        translations={translations}
                        isVertical={
                          attribute.layout === ATTRIBUTES.verticalLayout
                        }
                        question={updatedQuestion}
                        withTextReplyQuestions={isOpenEnded}
                        isEnpsOpenEndedQuestion={isEnpsOpenEndedQuestion}
                        isPreview
                        isAttributePreview
                        isSingleReview
                      />
                    );
                  })}
                </div>
              )}
              {!hasQuestions && (
                <NoDataText
                  className={classes.noData}
                  text={translations.noData}
                />
              )}
            </div>
          </Scrollbars>
        </div>
      </div>
    </CustomModal>
  );
};

PreviewAttributeDialog.propTypes = {
  translations: PropTypes.object.isRequired,
  isOpened: PropTypes.bool.isRequired,
  attribute: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default PreviewAttributeDialog;
